import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { NurseryTypeService } from '../proxy/planning/controllers/nursery-type.service';
import { ZoneService } from '../proxy/planning/controllers/zone.service';
import { TrayTypeService } from '@woodsecurity/proxy/wood-security/controllers/tray-type.service'
import { CostCenterService } from '@controlling/proxy/controlling/controllers/cost-center.service';

FieldBuilder.setNamespace('Planning');

export const NURSERY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Nursery.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .foreignKey('nurseryTypeId', 'Entity.NurseryType', NurseryTypeService)
    .required()
    .displayFromNested('nurseryType.name')
    .sortBy('nurseryType.name')
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .required()
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('costCenterId', 'Entity.Nursery.CostCenter', CostCenterService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const NURSERY_CONFIG = {
  entityName: 'Nursery',
  localizationKey: 'Planning::Entity.Nursery',
  permission: 'PlanningLocation.Nurseries',
  fields: NURSERY_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
